<template>
  <div
    class="data-page"
    :style="wrapStyle"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!-- <n-tabs :list="list" :is-top.sync="active" /> -->
    <div class="main">
      <n-scroll v-show="active === 'history'" @bottom="bottomCb">
        <!-- <n-form v-model="his.form" @confirm="confirm"></n-form> -->
        <n-card-list :list="his.checkList"></n-card-list>
      </n-scroll>
      <!-- <n-scroll v-show="active === 'statistics'">
        <n-tabs-btn :active.sync="statis.active" />
        <n-chart :title="'检测次数'" icon="bar" :option="bar" :chart-height="calc(426)" />
        <n-chart :title="'结果种类'" icon="pie" :option="pie" :chart-height="calc(426)" />
      </n-scroll> -->
    </div>
  </div>
</template>

<script>
import NScroll from '../../components/NScroll';
import NCardList from './components/card-list';
import { makeChart } from './utils/options';
import { get } from '@/api/remoteControl';
import { timer } from '@/utils/utils';

export default {
  name: 'VPData',
  inject: ['calc', 'params'],
  components: {
    NScroll,
    NCardList
  },
  data() {
    const barData = [11, 22, 33, 44, 55, 66, 77];
    const pieData = [
      { name: '毒品', value: 120 },
      { name: '危险化学品', value: 111 },
      { name: '爆炸物', value: 300 },
      { name: '军事毒剂', value: 500 }
    ];
    return {
      loading: false,
      active: 'history',
      list: [
        { text: '检测历史', name: 'history' },
        { text: '检测统计', name: 'statistics' }
      ],
      his: {
        form: {
          time: '',
          name: ''
        },
        checkList: []
      },
      statis: {
        active: 'week',
        barData,
        pieData
      },
      pagination: {
        offset: 1,
        total: 0,
        limit: 10,
        lastPage: 1
      }
    };
  },
  computed: {
    wrapStyle() {
      return {
        padding: `0 ${this.calc(30)}`
      };
    },
    bar() {
      return makeChart({
        title: '检测次数',
        type: 'bar',
        data: this.statis.barData,
        xData: [1, 2, 3, 4, 5, 6, 7]
      });
    },
    pie() {
      return makeChart({
        title: '结果种类',
        type: 'pie',
        data: this.statis.pieData
      });
    }
  },
  methods: {
    bottomCb() {
      this.getList(++this.pagination.offset);
    },
    confirm(v) {
      console.log(v);
    },
    cleaerLoading() {
      timer(() => {
        this.loading = false;
      }, 500);
    },
    getList(offset) {
      if (this.loading) return;
      const { limit, lastPage } = this.pagination;
      if (lastPage < offset) return;
      this.loading = true;
      const params = {
        offset,
        limit,
        sn: [this.params.sn]
      };
      get(params)
        .then(res => {
          const { data } = res;
          const { list, lastPage } = data.remoteDetectInfoPage || {};
          if (!list) return;
          const l = list.map(e => ({ name: e.materialNames, sn: e.testSeq, date: e.detectTime }));
          this.pagination.lastPage = lastPage;
          this.his.checkList.push(...l);
        })
        .finally(this.cleaerLoading);
    }
  },
  created() {
    console.log('created');
    this.getList(1);
  }
};
</script>

<style lang="scss" scoped>
.data-page {
  position: relative;
  max-height: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    height: 100%;
    overflow: hidden;
  }
}
</style>
